import { RecordFilter, Relation } from '@/types/api';

import { useFormContext } from 'react-hook-form';
import Item from '@/components/Record/SubjectContent/AttachmentConnect/DataItem/Item';

type P = {
  item: Relation;
  onDelete?: () => void;
  isFocused?: boolean;
};
const DataItem = ({ item, onDelete, isFocused }: P) => {
  const { getValues, setValue } = useFormContext<RecordFilter>();
  const handleDelete = () => {
    const current = getValues('relations'); // 기존 배열 가져오기
    const filtered = current.filter((d) => d.id !== item.id); // 현재 item.id 제외
    setValue('relations', filtered); // 업데이트
  };
  return <Item item={item} onDelete={handleDelete} isFocused={isFocused} />;
};
export default DataItem;
